// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import GenerictListTab from "./../../factories/generic-list-tab";

class BillingTab extends GenerictListTab {
    BillingFolder: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 1000;
        this.BillingFolder = parent;
    }
    ControllerUrl = "BillingTab";
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    Dialog(id: string): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([cancelButton]);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(vm);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
    MinimizeEntity(item) {
        var result = ko.map.toJS(item);
        return result;
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default BillingTab;